import type { FilterMode } from "./type";

export const activeConfiguration: { mode: FilterMode } = $state({ mode: "filterAccordion" });

export function setActiveConfiguration(mode: FilterMode) {
  activeConfiguration.mode = mode;
}
